var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{staticClass:"wb-backtop",attrs:{"right":22,"bottom":22,"visibility-height":600}},[_c('NhSvgIcon',{attrs:{"name":"arrowUp"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }